import { IProcessorState, ISlice, IRange } from '../constants'

export const getText = (state: IProcessorState): string => {
  return state.text
}

export const getSlices = (state: IProcessorState): ReadonlyArray<ISlice> => {
  return state.slices
}

export const getSlicesAt = (state: Pick<IProcessorState, 'slices'>, index: number): ISlice[] => {
  return state.slices.filter((s) => s.range.start <= index && index < s.range.end)
}

export const getSelection = (state: IProcessorState): IRange => {
  return state.selection
}
